/* eslint-disable */
import * as DateHelper from '../helpers/date'
import _ from 'lodash'


// export const doneToday = (routine) => {
//   return _.includes(_.map(routine.datesDone, formatyyymmdd), formatyyymmdd(midnight()))
// }

export default (routineEnity) => new RoutineEntity(routineEnity)

class RoutineEntity {
  // ..and an (optional) custom class constructor. If one is
  // not supplied, a default constructor is used instead:
  // constructor() { }
  constructor(routine) {
    // console.log('RoutineEntity()', routine.id)
    this.routine = routine
    this.memoizedUrgency = null
  }

  // Simple class instance methods using short-hand method
  // declaration

  countDoneIn (fromMidnight, toMidnight) {
    return _.filter(this.datesDone(), (dateDone) => {
      return DateHelper.dateIn(dateDone, fromMidnight, toMidnight)
     }).length
  }

  templateId () {
    return this.routine.templateId
  }

  isActive () {
    return !this.routine.paused
  }

  isPaused () {
    return !this.isActive()
  }

  isFinished () {
    return !!this.routine.finishedOn
  }

  isNotFinished () {
    return !this.isFinished()
  }

  isUnfinishedButToday () {
    return !this.isFinished() ||
      DateHelper.ensuredDateEqual(this.routine.finishedOn.toDate(), DateHelper.midnight())
  }

  isUrgent() {
    return this.urgency() >= 99
  }

  isShouldDo () {
    return this.urgency() < 99 && this.urgency() >= 70
  }

  isCouldDo () {
    return this.urgency() < 70 && this.urgency() >= 35
  }

  isDontHaveToDo () {
    return this.urgency() <= 35
  }

  lastDayDone () {
    return _.max(this.datesDone())
  }

  lastDayDoneButToday () {
    return _.max(
      _.reject(this.datesDone(), (d) => DateHelper.areEqual(d, DateHelper.midnight()) )
    )
  }

  datesDone () {
    if (this.routine.datesRaw) {
      return _.map(this.routine.datesRaw.split(','), (d) => DateHelper.parseInCurrentTimezone(d))
    } else {
      return []
    }
  }

  datesDoneCount () {
    return this.datesDone.length
  }

  doneToday () {
    return _.includes(_.map(this.datesDone(), DateHelper.formatyyymmdd), DateHelper.formatyyymmdd(DateHelper.midnight()))
  }

  skippedToday () {
    return this.routine.lastSkipOn && DateHelper.ensuredDateEqual(this.routine.lastSkipOn.toDate(), DateHelper.midnight())
  }

  urgency () {
    if (this.memoizedUrgency) return this.memoizedUrgency
    // if (this.doneToday()) return 0

    // debugger

    if (this.routine.frequency_period === 'daily') {
      this.memoizedUrgency = 99
    }
    else if (!this.lastDayDoneButToday()){
      this.memoizedUrgency = 99
    } else {
      this.memoizedUrgency =(_.min([this.lastDateDoneDistance() / this.maxDistance(), 0.99]) * 100)
    }

    return this.memoizedUrgency
  }

  createdOn () {
    return this.routine.createdAt.toDate()
  }

  existsForDays () {
    return DateHelper.datesDiff(DateHelper.midnight(), this.createdOn())
  }

  lastDateDoneDistance() {
    if (this.lastDayDoneButToday()) {
      return DateHelper.datesDiff(DateHelper.midnight(), this.lastDayDoneButToday())
    } else {
      const dayBeforeStart = DateHelper.midnight(this.routine.startedOn)
      dayBeforeStart.setDate(dayBeforeStart.getDate() - 1)
      return DateHelper.datesDiff(DateHelper.midnight(), dayBeforeStart)
    }
  }

  maxDistance () {
    if (this.routine.frequency_period === 'daily') return null

    const period = this.routine.frequency_period === 'month' ? 31 : 7
    return (period / this.routine.frequency_count)
  }
  // We will look at static and subclassed methods shortly
}



 // const urgency = (routine) => {
    // return 1
      // if (doneToday(routine)) return 0
//
      // if (routine.frequency_period === 'daily') return 99

      // return (_.min([lastDateDoneDistance / maxDistance, 0.99]) * 100)
// }


// export const datesDone = (routine) {
//       if (this.datesRaw) {
//         return _.map(this.datesRaw.split(','), (d) => midnight(d))
//       } else {
//         return []
//       }

//     },

// export const maxDistance = (routine) => {
//   if (routine.frequency_period === 'daily') return null

//   const period = routine.frequency_period === 'month' ? 31 : 7
//   return (period / routine.frequency_count)
// }

// export const lastDateDoneDistance = (routine) => {
//   if (routine.lastDayDone) {

//     return datesDiff(midnight(), routine.lastDayDone)
//   } else {
//     const dayBeforeStart = DateHelper.midnight(routine.startedOn)
//     dayBeforeStart.setDate(dayBeforeStart.getDate() - 1)
//     return DateHelper.datesDiff(DateHelper.midnight(), dayBeforeStart)
//   }
// }
